import { useCallback, useEffect, useState } from "react";

const HEADER_MENU_CLOSE_EVENT = "wm-header-menu-close";

export const closeAllHeaderMenus = () => {
  window.dispatchEvent(new CustomEvent(HEADER_MENU_CLOSE_EVENT));
};

export const handleHeaderMouseDownCapture = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }
  if (target.closest('[role="menu"]')) {
    return;
  }
  if (target.closest('button[aria-haspopup="menu"]')) {
    return;
  }
  closeAllHeaderMenus();
};

export const useHeaderMenuAnchor = (menuId) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  useEffect(() => {
    const close = (event) => {
      if (event.detail?.except === menuId) {
        return;
      }
      setAnchorEl(null);
    };
    window.addEventListener(HEADER_MENU_CLOSE_EVENT, close);
    return () => window.removeEventListener(HEADER_MENU_CLOSE_EVENT, close);
  }, [menuId]);

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleToggle = useCallback(
    (event) => {
      event.stopPropagation();
      setAnchorEl((current) => {
        if (current) {
          return null;
        }
        window.dispatchEvent(
          new CustomEvent(HEADER_MENU_CLOSE_EVENT, {
            detail: { except: menuId },
          })
        );
        return event.currentTarget;
      });
    },
    [menuId]
  );

  const handleClose = useCallback((event, reason) => {
    setAnchorEl((current) => {
      if (!current) {
        return null;
      }
      if (reason === "backdropClick" && current.contains(event?.target)) {
        return current;
      }
      return null;
    });
  }, []);

  return { anchorEl, isOpen, handleToggle, handleClose, closeMenu };
};
